import { render, staticRenderFns } from "./Alokasi.vue?vue&type=template&id=f87c47e2&scoped=true"
import script from "./Alokasi.vue?vue&type=script&lang=js"
export * from "./Alokasi.vue?vue&type=script&lang=js"
import style0 from "./Alokasi.vue?vue&type=style&index=0&id=f87c47e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f87c47e2",
  null
  
)

export default component.exports